export default __webpack_public_path__ + "static/media/visibility-off-icon.ac3d4ff6.svg";